var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmendDeleteMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16.5,
    stroke: "#00893F",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.498 18.9439C20.7565 20.0732 23.1824 19.4222 24.9164 17.4898C25.6122 16.7143 26.0909 15.8503 26.3333 15.0207V24.0002C26.3333 24.9168 25.5833 25.6668 24.6666 25.6668H11.3333C10.4166 25.6668 9.66663 24.9168 9.66663 24.0002L9.67496 14.0002C9.67496 13.0835 10.4166 12.3335 11.3333 12.3335H21.5591C21.1392 12.6261 20.7329 12.9834 20.3589 13.4003C19.1296 14.7702 18.5781 16.4162 18.8096 17.6608L18 18.1668L11.3333 14.0002V15.6668L18 19.8335L19.4677 18.9162C19.4777 18.9255 19.4878 18.9348 19.498 18.9439Z",
    fill: "#FFC20E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.3121V18.0002H21.688L26.6667 13.0215L24.9786 11.3335L20 16.3121Z",
    fill: "#00893F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8671 11.8357C28.0442 11.6586 28.0442 11.3725 27.8671 11.1954L26.8045 10.1328C26.6274 9.95573 26.3413 9.95573 26.1642 10.1328L25.3333 10.9638L27.0361 12.6667L27.8671 11.8357Z",
    fill: "#00893F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmendDeleteMessage);
export default __webpack_public_path__ + "static/media/amend-delete-message.6e666709.svg";
export { ForwardRef as ReactComponent };